export type Tag = { name: string, type: TagType };

export enum TagType {
    Default = 'Default',
    Custom = 'Custom',
    Cancelled = 'Cancelled',
    Targeted = 'Targeted',
    Gps = 'Gps',
}
